var _rect, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentMethodAppOta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1719 6.375H4.82812C4.23262 6.375 3.75 6.85762 3.75 7.45312V16.5469C3.75 17.1424 4.23262 17.625 4.82812 17.625H19.1719C19.7674 17.625 20.25 17.1424 20.25 16.5469V7.45312C20.25 6.85762 19.7674 6.375 19.1719 6.375Z",
    fill: "url(#paint0_linear_1397_3943)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 8.25H3.75V9.75H20.25V8.25Z",
    fill: "#FEC84B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 12H5.25C5.043 12 4.875 11.832 4.875 11.625V10.875C4.875 10.668 5.043 10.5 5.25 10.5H18.75C18.957 10.5 19.125 10.668 19.125 10.875V11.625C19.125 11.832 18.957 12 18.75 12Z",
    fill: "#D1E9FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1397_3943",
    x1: 6.1425,
    y1: 6.375,
    x2: 21.7451,
    y2: 10.0971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E90FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1570EF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentMethodAppOta);
export default __webpack_public_path__ + "static/media/payment-method-app-ota.3b49277e56ea7ae0a7d0fe9f01fb5e96.svg";
export { ForwardRef as ReactComponent };